module.exports = __webpack_public_path__ + "static/contents2-2bb61239e2d865e641973b08514e97f7.jpg";